import { useSelector } from "react-redux";
import { TabMobile, TabsMobile } from "../tabsMobile/TabsMobile";
import Text from "../../features/text/Text";
import CheckBox from "../checkbox/CheckBox";
import Collapse from "../collapse/Collapse";
import classes from "./Filters.module.css";
import { AccessibilityClickableDiv } from '@skillz/accessibility';

const Filters = ({ filters, setFilters, collapse, clearAll, border, isMobile, setOpenFilters, DropContentClass, dropClassBtnWrapper, dropClassContent, expanded, closeCollapse, setCloseCollapse, listboxId }) => {
    const texts = useSelector(state => state.translate.texts);

    const handleChange = (checked, filterName, valueName) => {
        setFilters(preFilters =>
            preFilters.map(filter => ({
                ...filter,
                values: filter.values.map(value => value.name === valueName ?
                    { ...value, check: checked }
                    :
                    value)
            }))
        )
    }

    const clearFilters = () => {
        setFilters(preFilters =>
            preFilters.map(filter => ({
                ...filter,
                values: filter.values.map(value => ({ ...value, check: false }))
            }))
        )
    }

    const filtersValues = (filter) => {
        return filter.values.filter(value => !value.hide).map((value, index) => <CheckBox
            key={value.name}
            onChange={(checked) => handleChange(checked, filter.name, value.name)}
            checked={value.check}
            value={value.name}
            color={value.color || "black"}
            role="option"
            id={`${listboxId}-${filter.name}-${index}`}>
            <Text>{value.text}</Text>
        </CheckBox>)
    }

    const filtersCount = filters?.flatMap(filter => filter.values)?.filter(value => value.check).length;
    const countFilters = filters?.filter(filter => !filter.hideFilter)?.length;
    const filtersElems = filters && filters.map(filter => {

        const allValuesHidden = filter.values.every(value => value.hide);
        return (
            filters?.length > 1 && !allValuesHidden && countFilters > 1 ?
                <Collapse
                    key={filter.name}
                    title={filter.text}
                    listboxId={`${listboxId}-${filter.name}`}
                    dropClass={classes.Collapse}
                    expanded={expanded !== undefined ? expanded : true}
                    closeCollapse={closeCollapse}
                    setCloseCollapse={setCloseCollapse}
                    selector={'label'}>
                    <div className={classes.Values}>
                        {filtersValues(filter)}
                    </div>
                </Collapse>
                :
                <div className={`${classes.Values} ${classes.SingleCategory}`}>
                    {filtersValues(filter)}
                </div>
        );
    });

    return (
        <div className={classes.FiltersWrap} style={{ border: border && "1px solid #E2E2E2" }}>
            {!isMobile ?
                <>
                    {collapse ?
                        <Collapse listboxId={listboxId}
                            dropClass={classes.Filters}
                            title={`${texts.filterBy ?? ""} ${filtersCount ? `(${filtersCount})` : ""}`}
                            expanded={false}
                            dropClassBtnWrapper={dropClassBtnWrapper}
                            dropClassContent={dropClassContent}
                            clearAll={clearAll}
                            clearFilters={clearFilters}
                            closeCollapse={closeCollapse}
                            selector={"label"}>
                            {filtersElems}
                        </Collapse>
                        :
                        <div className={DropContentClass}>
                            <div className={classes.Header}>
                                <p>{texts.filterBy} </p>
                                {clearAll &&
                                    <AccessibilityClickableDiv onClick={clearFilters}>
                                        <p className={classes.ClearAll}>{texts.clearAll}</p>
                                    </AccessibilityClickableDiv>}
                            </div>
                            {filtersElems}
                        </div>
                    }
                </>
                :
                <>
                    {<TabsMobile smallScreenResult dropClassTab={classes.DropClassTab} dropClassTabs={classes.DropClassTabs} title={texts.filterBy} closePopup={() => setOpenFilters(false)} height="365px">

                        {filters && filters.map((filter, index) => {
                            const allValuesHidden = filter.values.every(value => value.hide);
                            if (!filter.hideFilter)
                                return (<TabMobile key={filter.name} name={filter.text} arrow>
                                    {!allValuesHidden && <div className={classes.MobileTabContent}>
                                        {clearAll &&
                                            <AccessibilityClickableDiv onClick={clearFilters}>
                                                <p className={classes.ClearAll}>{texts.clearAll}</p>
                                            </AccessibilityClickableDiv>}
                                        {filter.values.map(value => {
                                            if (!value.hide) {
                                                return (
                                                    <CheckBox
                                                        key={value.name}
                                                        onChange={(checked) => handleChange(checked, filter.name, value.name)}
                                                        checked={value.check}
                                                        value={value.name}
                                                        color={value.color || "black"}
                                                        role="option"
                                                        id={`${listboxId}-${value.name}-${index}`}>
                                                        <Text className={classes.text}>{value.text}</Text>
                                                    </CheckBox>);
                                            }
                                            return null;
                                        })}
                                    </div>}
                                </TabMobile>)
                        })}
                    </TabsMobile>}
                </>
            }

        </div>
    )
}


export default Filters;